import { IOdataFilter } from './IOdataFilter';
import { IOdataField } from '../Field/IOdataField';

export class OdataFilterStartsWith implements IOdataFilter {
  private field1: IOdataField;
  private field2: IOdataField;

  constructor(field: IOdataField, startsWithValue: IOdataField) {
    this.field1 = field;
    this.field2 = startsWithValue;
  }

  toFilterString() {
    return `startsWith(${this.field1.toFieldString()}, ${this.field2.toFieldString()})`;
  }
}
